import { ExternalLink, History, LifeBuoy } from 'lucide-react';
import Panel from './Panel';

const HelpPanel = ({ supportEmail, onNavigate }) => (
  <Panel title="Help resources" testId="help-resources" bodyClassName="">
    <ul className="divide-y divide-border">
      <li>
        <a
          href={`mailto:${supportEmail}`}
          className="flex items-center gap-3 px-4 py-3 text-sm hover:bg-accent transition-colors"
        >
          <LifeBuoy className="w-4 h-4 text-muted-foreground shrink-0" />
          <span className="flex-1">
            <span className="block font-medium">Contact support</span>
            <span className="block text-xs text-muted-foreground">{supportEmail}</span>
          </span>
          <ExternalLink className="w-3.5 h-3.5 text-muted-foreground" />
        </a>
      </li>
      <li>
        <button
          type="button"
          onClick={() => onNavigate('/history')}
          className="w-full flex items-center gap-3 px-4 py-3 text-sm text-left hover:bg-accent transition-colors"
        >
          <History className="w-4 h-4 text-muted-foreground shrink-0" />
          <span className="flex-1">
            <span className="block font-medium">Filing history</span>
            <span className="block text-xs text-muted-foreground">Submitted filings and acknowledgements</span>
          </span>
        </button>
      </li>
    </ul>
  </Panel>
);

export default HelpPanel;
